import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { ApiBaseService } from "../../common/providers/api-base-service";
import { Athlete } from "../../common/models/athlete";
import { Organization } from "../../common/models/organization";
import { CurrentUser } from "../../common/providers/current-user";
import { User } from "../../common/models/user";

@Injectable({providedIn: 'root'})
export class SessionExportService {
    constructor(
        private api: ApiBaseService,
        private currentUser: CurrentUser,
    ) {}

    public export(organization: Organization, athleteUser: User, payload: Object = {}): Observable<any> {
        return this.api.call('post',`organizations/${organization.code}/athletes/${athleteUser.id}/sessions/export`, payload, this.currentUser.getAccessToken());
    }
}
